<template>
  <div class="topPrice">
    <div class="topPrice__title">誰の占いを見る？</div>
    <ul class="topPrice__list">
      <li class="topPrice__item">
        <span class="topPrice__label">価格</span>
        <span class="topPrice__price">各 ¥999<small>(税込)</small></span>
      </li>
      <!-- <li class="topPrice__item topPrice__item--subsc">
        <span class="topPrice__label">月額会員価格</span>
        <span class="topPrice__price">各 ¥0(見放題)</span>
      </li> -->
    </ul>
  </div>
</template>

<script>
export default {
  name: "topPrice",
}
</script>

<style scoped lang="scss">
.topPrice {
  $root: &;
  background: #F5F7FA;
  margin: 0 auto;
  max-width: 385px;
  &__title {
    background: #412E2E;
    font-weight: bold;
    font-size: 24px;
    line-height: 20px;
    text-align: center;
    letter-spacing: 1px;
    color: #FFE63C;
    padding: 15px;
  }
  &__list {
    padding: 16px 0;
    margin: 0 auto;
    display: table;
  }
  &__item {
    display: block;
    padding: 0;
    margin: 0 0 8px;
    &:last-child {
      margin-bottom: 0;
    }
    &--subsc {
      #{$root}__label {
        background: linear-gradient(86.53deg, #FF7497 21.4%, #CB8BFF 76.64%);
      }
      #{$root}__price {
        color: #FF7497;
      }
    }
  }
  &__label {
    display: inline-block;
    min-width: 7.75em;
    padding: 5px 5px 6px;
    background: #656D78;
    border-radius: 100px;
    font-weight: bold;
    font-size: 12px;
    line-height: 1;
    text-align: center;
    color: #FFFFFF;
  }
  &__price {
    display: inline-block;
    font-weight: bold;
    font-size: 16px;
    line-height: 20px;
    color: #32373F;
    &::before {
      content: '・・・・・';
      letter-spacing: -8px;
      margin-right: 8px;
    }
    small {
      font-size: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/YearLuck/y2022/topPrice.vue